import { Flex } from '@chakra-ui/react';
import { ProductFeatures } from '@client/graphql/__generated__/types';
import { Navigate } from 'react-router';
import { OfferScorecardsForOrg } from '~/apps/consumer/components/OfferScorecard/OfferScorecardsForOrg';
import { NotSupportedMarket } from '~/apps/consumer/components/ProductFeatures/NotSupportedMarket';
import {
  FeatureKey,
  useIsFeatureEnabledForPayload,
} from '~/apps/consumer/hooks/useIsFeatureEnabledForPayload';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { CONTAINER_PADDINGS } from '../../../components/Layouts/Container';

export const OrganizationOfferScorecardsPage = () => {
  const {
    selectedOrganization,
    loadingOrganizations,
    loadingIsSelectedOrgAdmin,
    isFeatureSupported,
  } = useAppContext();

  const isOfferScorecardEnabled = useIsFeatureEnabledForPayload({
    featureFlagKey: FeatureKey.OFFER_COACH,
    organizationId: selectedOrganization?.id,
  });

  if (loadingOrganizations || loadingIsSelectedOrgAdmin) {
    return <CenterSpinner />;
  }

  if (isOfferScorecardEnabled === false) {
    return <Navigate to="/organizations" />;
  }

  if (!isFeatureSupported(ProductFeatures.OFFER_SCORECARD)) {
    return <NotSupportedMarket />;
  }

  return (
    <Flex
      direction="column"
      gap={4}
      height="100vh"
      width={{ base: '100%', md: '80%' }}
      {...CONTAINER_PADDINGS}
    >
      <OfferScorecardsForOrg />
    </Flex>
  );
};
